<template>
    <div :style="theme.form">
        <h1 :style="theme.header" v-if="!submitView">Verify Contact</h1>
        <h1 :style="theme.header" v-if="submitView">Submit Code</h1>
        <div v-if="!submitView">
            <div :style="[theme.inputRow, {textAlign: 'left'}]" v-if="this.unverified.email">
                <input :style="theme.radio" type="radio" v-on:click="verifyEmail"/>
                {{this.unverified.email}}
            </div>
            <div :style="[theme.inputRow, {textAlign: 'left'}]" v-if="this.unverified.phone_number">
                <input :style="theme.radio" type="radio" v-on:click="verifyPhoneNumber"/>
                {{this.unverified.phone_number}}
            </div>
            <div :style="theme.actionRow">
                <button :style="theme.action" v-on:click="send">Send Code</button>
            </div>
        </div>
        <div v-if="submitView">
            <div :style="theme.inputRow">
                <input :style="theme.input" v-model="code" placeholder="Code"/>
            </div>
            <div :style="theme.actionRow">
                <button :style="theme.action" v-on:click="submit" :disabled="!code">Submit</button>
            </div>
        </div>
        <div :style="theme.footer">
            &nbsp;
            <span :style="theme.footerRight">
        <a :style="theme.link" v-on:click="skip">Skip</a>
      </span>
        </div>
        <div :style="theme.error" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import AmplifyTheme from '../../style/AmplifyTheme'

const logger = new Logger('SignInComp')

export default {
    name: 'VerifyContact',
    data () {
        return {
            verifyAttr: '',

            submitView: false,
            code: '',

            error: '',
            theme: AmplifyTheme
        }
    },
    computed: {
        unverified () {
            const verification = this.$store.getters['auth/userVerification']
            return verification && verification.unverified
                ? verification.unverified
                : []
        }
    },
    created () {
        const verification = this.$store.getters['auth/userVerification']
        if (!verification) {
            this.$router.push('/').catch(err => err)
        }
    },
    methods: {
        verifyEmail () {
            this.verifyAttr = 'email'
        },
        verifyPhoneNumber () {
            this.verifyAttr = 'phone_number'
        },
        send () {
            Auth.verifyCurrentUserAttribute(this.verifyAttr).then(data => {
                logger.debug(data)
                this.submitView = true
            }).catch(err => this.setError(err))
        },
        submit () {
            Auth.verifyCurrentUserAttributeSubmit(this.verifyAttr, this.code).then(() => {
                this.$router.push('/').catch(err => err)
            }).catch(err => this.setError(err))
        },
        skip () {
            this.$router.push('/').catch(err => err)
        },
        setError (err) {
            this.error = err ? err.message || err : ''
        }
    }
}
</script>
